import { render, staticRenderFns } from "./ViewerInsertPictogramsModal.vue?vue&type=template&id=e8646388"
import script from "./ViewerInsertPictogramsModal.vue?vue&type=script&lang=js"
export * from "./ViewerInsertPictogramsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports